//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { version } from '../../package.json';

import activeChecked from './assets/default/checked.svg';
import activeNoChecked from './assets/default/nochecked.svg';
import disabledChecked from './assets/disabled/checked.svg';
import disabledNoChecked from './assets/disabled/nochecked.svg';
import readonlyChecked from './assets/readonly/checked.svg';
import readonlyNoChecked from './assets/readonly/nochecked.svg';
import hoveredNoChecked from './assets/hover/hovered.svg';
import hoveredChecked from './assets/hover/checked-hovered.svg';
import invalidNoChecked from './assets/invalid/invalid.svg';

export default {
  name: 'ViuCheckbox',
  props: {
    /**
     * Modelo que determinará si el checkbox está activo o no.
     */
    value: [Array, Boolean],
    /**
     * Propiedad para indicar si el checkbox es de solo lectura, deshabilitando la posibilidad de modificar el valor.
     */
    readOnly: Boolean,
    /**
     * Propiedad para indicar si el checkbox esta deshabilitado.
     */
    disabled: Boolean,
    /**
     * Valor que añade o elimina el checkbox si el :value es un array.
     */
    content: [String, Number],
    /**
     * se establecen estilos
     * en funcion de su valor
     * si es invalido
     */
    invalid: {
      type: Boolean,
      default: false
    },
    /**
     * Define si sera requerido al hacer la comprobación.
     */
    required: Boolean,
    /**
     * Establecer clases en elemento donde lanza los eventos para testing QA
     */
    dusk: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    activeChecked,
    activeNoChecked,
    disabledChecked,
    disabledNoChecked,
    readonlyChecked,
    readonlyNoChecked,
    hoveredNoChecked,
    hoveredChecked,
    invalidNoChecked,
    invalidStorage: false,
    hovered: false,
    version
  }),
  computed: {
    currentCheckbox() {
      if (this.disabled) {
        return this.isChecked ? this.disabledChecked : this.disabledNoChecked;
      }
      if (this.readOnly) {
        return this.isChecked ? this.readonlyChecked : this.readonlyNoChecked;
      }
      if (this.invalid && !this.value) {
        return this.invalidNoChecked;
      }
      if (this.isInvalid) {
        return this.invalidNoChecked;
      }
      if (this.hovered) {
        return this.isChecked ? this.hoveredChecked : this.hoveredNoChecked;
      }
      return this.isChecked ? this.activeChecked : this.activeNoChecked;
    },
    isChecked() {
      return Array.isArray(this.value) ? this.value.includes(this.content) : this.value;
    },
    isInvalid() {
      return this.invalid !== false || this.invalidStorage;
    }
  },
  watch: {
    value() {
      this.invalidStorage = false;
    }
  },
  methods: {
    onClick() {
      if (!this.disabled && !this.readOnly) {
        const valueToEmit = this.getValueToEmit();
        /**
         * Evento que modificará el valor del v-model pasado al checkbox.
         *
         * @event input
         * @property {boolean|array} valueToEmit Valor modificado que tomará el modelo asignado a este checkbox
         */
        this.$emit('input', valueToEmit);
      }
    },
    getValueToEmit() {
      if (Array.isArray(this.value)) {
        if (this.value.includes(this.content)) {
          this.value.splice(this.value.indexOf(this.content), 1);
        } else {
          this.value.push(this.content);
        }
        return this.value;
      }
      return !this.value;
    },
    checkInvalid() {
      const { required } = this;
      let status = false;
      let reason = '';

      this.invalidStorage = false;
      if (
        required &&
        ((typeof this.value === 'boolean' && !this.value) ||
          (Array.isArray(this.value) && this.value.length === 0))
      ) {
        status = true;
        reason = 'Este campo es requerido';
        this.invalidStorage = status;
        return { status, reason };
      }

      return { status, reason };
    }
  }
};
